module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showcont),
      expression: "showcont"
    }],
    attrs: {
      "id": "InviteCard"
    }
  }, [_c('img', {
    attrs: {
      "id": "imgecard",
      "src": _vm.imgSrc
    },
    on: {
      "click": _vm.changeThem
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "u-btn",
    on: {
      "click": _vm.changeThem
    }
  }, [_vm._v("更换邀请卡主题")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "Label"
  }, [_vm._v("如何玩转邀请卡")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n\t\t\t1.公开话题/加密话题邀请好友来看直播，榜上有名;"), _c('br'), _vm._v(" 2.长按保存图片发送给好友即可邀请;\n\t\t\t"), _c('br'), _vm._v(" 3.点击\"更换邀请卡主题\"，切换邀请卡主题样式。\n\t\t\t"), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-167dc27e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/InviteCard.vue
// module id = 427
// module chunks = 0